import React from 'react';

export { default as Article } from './ArticleDocument';
export { default as Contest } from './ArticleDocument';
export { default as Video } from './VideoDocument';
export { default as Podcast } from './VideoDocument';
export { default as Interactive } from './InteractiveDocument';
export { default as Newsletter } from './NewsletterDocument';
// export { default as Micromag } from './MicromagDocument';
// export { default as ArticleLegacy } from './ArticleLegacyDocument';
// export const Video = React.lazy(() => import(/* webpackChunkName: "document_video" */'./VideoDocument'));
export const ArticleLegacy = React.lazy(
    () => import(/* webpackChunkName: "document_article_legacy" */'./ArticleLegacyDocument'),
);
export const Micromag = React.lazy(
    () => import(/* webpackChunkName: "document_micromag" */'./MicromagDocument'),
);
